import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./pages/login/login').then(m => m.Login) },
  { path: 'forums', loadComponent: () => import('./pages/forums/forums').then(m => m.Forums), canActivate: [authGuard] },
  { path: '', loadComponent: () => import('./pages/home/home').then(m => m.Home), canActivate: [authGuard] },
  { path: '**', redirectTo: '' }
];
